import React from 'react';

// @material-ui/core components

// core components
import GridContainer from '@components/Grid/GridContainer.js';
import GridItem from '@components/Grid/GridItem.js';

import { Formik, FormikProps } from 'formik';
import { customerValidationSchema } from 'apps/things/app/validations';
import ItemForm from './ItemForm';
import CardWrapper from '@components/Card/CardWrapper';
import { UpdateClientPersonInput } from '../../types/clientServiceGlobalTypes';

interface IRTable {
  title?: string;
  TableAction?: React.ReactNode;
  bulkDeleteProducts?: () => void;
  handleSubmit: (payload: UpdateClientPersonInput) => void;
  isLoading: boolean;
  item: UpdateClientPersonInput;
}

const AddItem: React.FC<IRTable> = ({ handleSubmit, isLoading, item }) => {
  return (
    <GridContainer>
      <GridItem xs={12} sm={12} md={12}>
        <CardWrapper>
          {item?.personId && (
            <Formik
              onSubmit={async (values: any) => handleSubmit(values)}
              initialValues={item}
              validationSchema={customerValidationSchema}
              validateOnChange={true}
            >
              {(formBag) => (
                <ItemForm
                  formBag={
                    (formBag as unknown) as FormikProps<UpdateClientPersonInput>
                  }
                  disableLoginButton={isLoading}
                />
              )}
            </Formik>
          )}
        </CardWrapper>
      </GridItem>
    </GridContainer>
  );
};

export default AddItem;
